import React from "react";
import { ObjectFieldTemplateProps } from "@rjsf/utils";

export default function MeasureAnswersObjectTemplate({
  properties,
  schema,
}: ObjectFieldTemplateProps) {
  return (
    <div className="grid grid-cols-[minmax(0,9fr)_minmax(0,7fr)] gap-x-4 gap-y-3">
      {properties.map((element) => {
        const question = schema.properties?.[element.name]?.title;

        return (
          <React.Fragment key={element.name}>
            <div className="flex items-start pt-1 text-sm font-semibold text-primary-800">
              {question}
            </div>
            <div className="min-w-0 measure-answer-field">
              {element.content}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}